import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaHeart,
  FaCameraRetro,
  FaStar,
} from "react-icons/fa";

/* =========================
   IMÁGENES
========================= */
import a1 from "../../src/components/assets/images/trayectoria/a1.jpg";
import a2 from "../../src/components/assets/images/trayectoria/a2.jpg";
import a3 from "../../src/components/assets/images/trayectoria/a3.jpg";
import b1 from "../../src/components/assets/images/trayectoria/a5.jpg";
import b2 from "../../src/components/assets/images/trayectoria2/b4.jpg";
import b3 from "../../src/components/assets/images/trayectoria2/b5.jpg";
import c1 from "../../src/components/assets/images/trayectoria3/DSC01963.JPG";
import c2 from "../../src/components/assets/images/xdxd.jpg";
import c3 from "../../src/components/assets/images/desfile.jpg";

/* =========================
   GALERÍA
========================= */
const recuerdos = [
  {
    src: a1,
    year: "2020",
    title: "Talento Cevatur",
    desc: "Nuestros estudiantes brillando con alegría y pasión.",
  },
  {
    src: a2,
    year: "2020",
    title: "Momentos Únicos",
    desc: "Sonrisas que quedaron para siempre.",
  },
  {
    src: a3,
    year: "2021",
    title: "Nueva Generación",
    desc: "Jóvenes construyendo su futuro profesional.",
  },
  {
    src: b1,
    year: "2018",
    title: "Fiesta de Promoción",
    desc: "Celebrando metas cumplidas y nuevos caminos.",
  },
  {
    src: b2,
    year: "2019",
    title: "Orgullo Institucional",
    desc: "Representando a Cevatur con excelencia.",
  },
  {
    src: b3,
    year: "2024",
    title: "Seguimos Creciendo",
    desc: "Más historias, más sueños, más futuro.",
  },
  {
    src: c1,
    year: "2021",
    title: "Despedida Emotiva",
    desc: "Un cierre lleno de emociones y recuerdos.",
  },
  {
    src: c2,
    year: "2022",
    title: "Evento Especial",
    desc: "Experiencias inolvidables fuera del aula.",
  },
  {
    src: c3,
    year: "2023",
    title: "Desfile Gastronómico",
    desc: "Creatividad, cultura y pasión profesional.",
  },
];

/* =========================
   COMPONENTE
========================= */
const TrayectoriaPage = () => {
  const [current, setCurrent] = useState(0);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % recuerdos.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const next = () => {
    setCurrent((prev) => (prev + 1) % recuerdos.length);
  };

  const prev = () => {
    setCurrent((prev) => (prev - 1 + recuerdos.length) % recuerdos.length);
  };

  const item = recuerdos[current];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-[#fffaf7] to-[#eef5ff] overflow-hidden">


      {/* HERO */}
      <section className="relative py-20 px-4">
        {/* decoración */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-red-200 rounded-full blur-3xl opacity-30"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-blue-200 rounded-full blur-3xl opacity-30"></div>

        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
          {/* TEXTO */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <span className="text-red-600 uppercase tracking-[5px] font-bold text-sm">
              Nuestra Historia
            </span>

            <h1 className="text-6xl md:text-5xl font-black leading-tight text-slate-900 mt-5">
              Recuerdos que
              <span className="block text-blue-700">viven para siempre</span>
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-relaxed max-w-xl">
              La trayectoria de Cevatur no se mide solo en años, sino en
              emociones, amistades, logros y generaciones que crecieron junto a
              nosotros.
            </p>

            {/* cards */}
            <div className="grid grid-cols-3 gap-4 mt-10">
              <MiniCard icon={<FaHeart />} title="50+" text="Años" />
              <MiniCard icon={<FaCameraRetro />} title="1000+" text="Fotos" />
              <MiniCard icon={<FaStar />} title="Miles" text="Historias" />
            </div>

            {/* frase */}
            <div className="mt-10 bg-white/90 backdrop-blur-md rounded-3xl p-6 shadow-xl border border-white">
              <p className="italic text-slate-700 text-lg">
                “Cada promoción dejó una huella. Cada alumno escribió una parte
                de nuestra historia.”
              </p>
            </div>
          </motion.div>

          {/* SLIDER WOW */}
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            className="relative"
          >
            <div className="relative rounded-[35px] overflow-hidden shadow-2xl border-8 border-white">
              <AnimatePresence mode="wait">
                <motion.div
                  key={current}
                  initial={{ opacity: 0, scale: 1.05 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.7 }}
                >
                  <img
                    src={item.src}
                    alt={item.title}
                    onClick={() => setModal(true)}
                    className="w-full h-[620px] object-cover cursor-pointer"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>

                  <div className="absolute bottom-0 left-0 p-8 text-white">
                    <span className="bg-red-600 px-4 py-1 rounded-full text-sm font-bold">
                      {item.year}
                    </span>

                    <h2 className="text-4xl font-black mt-4">
                      {item.title}
                    </h2>

                    <p className="text-gray-200 mt-2 max-w-lg">
                      {item.desc}
                    </p>
                  </div>
                </motion.div>
              </AnimatePresence>

              {/* botones */}
              <button
                onClick={prev}
                className="absolute left-5 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition"
              >
                <FaChevronLeft />
              </button>

              <button
                onClick={next}
                className="absolute right-5 top-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:scale-110 transition"
              >
                <FaChevronRight />
              </button>
            </div>

            {/* mini thumbs */}
            <div className="grid grid-cols-5 gap-3 mt-5">
              {recuerdos.slice(0, 5).map((img, i) => (
                <img
                  key={i}
                  src={img.src}
                  onClick={() => setCurrent(i)}
                  className={`h-20 w-full object-cover rounded-2xl cursor-pointer border-4 transition ${
                    current === i
                      ? "border-red-500 scale-105"
                      : "border-white hover:scale-105"
                  }`}
                  alt=""
                />
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* BLOQUE EMOTIVO */}
      <section className="pb-20 px-4">
        <div className="max-w-7xl mx-auto bg-white rounded-[35px] shadow-2xl p-10 border">
          <h2 className="text-4xl font-black text-slate-900 text-center">
            Más que una institución
          </h2>

          <p className="text-center text-slate-600 max-w-3xl mx-auto mt-5 text-lg leading-relaxed">
            Somos recuerdos compartidos, metas cumplidas, amistades que nacieron
            en aulas y sueños que despegaron con fuerza.
          </p>

          <div className="grid md:grid-cols-3 gap-6 mt-10">
            <EmotionCard
              title="Amistad"
              text="Lazos que nacieron en clase y duran toda la vida."
            />
            <EmotionCard
              title="Superación"
              text="Historias de alumnos que hoy son profesionales."
            />
            <EmotionCard
              title="Orgullo"
              text="Cada promoción representa esfuerzo y éxito."
            />
          </div>
        </div>
      </section>

      {/* MODAL */}
      <AnimatePresence>
        {modal && (
          <motion.div
            className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <motion.div
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              className="bg-white rounded-[30px] overflow-hidden max-w-4xl w-full relative shadow-2xl"
            >
              <button
                onClick={() => setModal(false)}
                className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white shadow flex items-center justify-center"
              >
                <FaTimes />
              </button>

              <img
                src={item.src}
                alt=""
                className="w-full h-[520px] object-cover"
              />

              <div className="p-8">
                <span className="text-red-600 font-bold">{item.year}</span>
                <h3 className="text-4xl font-black mt-2">{item.title}</h3>
                <p className="text-slate-600 mt-4 text-lg">{item.desc}</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

/* MINI CARD */
const MiniCard = ({ icon, title, text }) => (
  <div className="bg-white rounded-2xl p-5 shadow-lg border text-center">
    <div className="text-red-500 text-2xl flex justify-center mb-3">
      {icon}
    </div>
    <h3 className="text-2xl font-black">{title}</h3>
    <p className="text-sm text-slate-500">{text}</p>
  </div>
);

/* EMOTION CARD */
const EmotionCard = ({ title, text }) => (
  <div className="rounded-3xl bg-gradient-to-br from-white to-slate-50 border p-7 shadow-md hover:shadow-xl transition">
    <h3 className="text-2xl font-bold text-slate-900">{title}</h3>
    <p className="text-slate-600 mt-3 leading-relaxed">{text}</p>
  </div>
);

export default TrayectoriaPage;